export async function validateCode(url: RequestInfo, token: string, hash: string) {

    return await fetch(url + '/api/validate-code', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(
            {
                'token': token,
                'hash': hash,
            }
        )
    })
        .then(response => response.json())
        .catch(err => {
            console.log(err);
        });
}